import { LearnedRecommendation } from '@coach-bot/data-access/shared/interfaces/learned-recommendation.interface';
import { IXL_PRACTICE_SUMMARY_REQUEST_PATH, IXL_SAVE_QUIZ_RESPONSE_REQUEST_PATH } from '@shared/utils/constants/urls';
import { getLearningApp } from '@shared/utils/utils/learning-app';
import { Services } from '../services';

const APPS_TO_HANDLE: string[] = ['IXL'];
const PATHS_TO_HANDLE: string[] = [IXL_PRACTICE_SUMMARY_REQUEST_PATH, IXL_SAVE_QUIZ_RESPONSE_REQUEST_PATH];

export function startHandlingWebRequestCompleted(services: Services): void {
  chrome.webRequest.onCompleted.addListener(
    async function(details: chrome.webRequest.WebResponseCacheDetails) {
      if (details.tabId < 0) {
        return;
      }
      const url = new URL(details.url);
      const learningApp: string = getLearningApp(url.hostname);
      if (APPS_TO_HANDLE.includes(learningApp) && PATHS_TO_HANDLE.some((path: string) => url.pathname.includes(path))) {
        const resourceUrl: string = await getResourceUrl(details.tabId);
        const learnedRecommendation: LearnedRecommendation = {
          detailsRequestUrl: details.url,
          learnedTime: Date.now(),
          resourceId: '',
          resourceUrl,
        };
        services.learningService.handleLearningCompleted(learnedRecommendation);
      }
    },
    {urls: ["<all_urls>"]}
  );
}

async function getResourceUrl(tabId: number): Promise<string> {
  return new Promise((resolve, reject) => {
    chrome.tabs.get(tabId, (tab: chrome.tabs.Tab) => {
      if (chrome.runtime.lastError) {
        reject(chrome.runtime.lastError.message);
      } else {
        resolve(tab.url);
      }
    });
  });
}
